/**
 * @file コンポーネント：検索執刀医絞り込み スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledList = styled.ul``;
